import {Component} from '@angular/core';

import {ControlWidget} from '../../widget';

@Component({
  selector: 'app-sf-radio-widget',
  templateUrl: './sf-radio-widget.component.html'
})
export class RadioWidgetComponent extends ControlWidget {
}
